module.exports = __webpack_public_path__ + "img/tuihuanhuo.eaf0eeaf.png";